import { Box } from "@intech/web-ui";
import React from "react";
import { Container, Loader, LoaderText } from "./styles";

export const LoadingComponent: React.FC<{ title?: string }> = ({ title = "Carregando..." }) => {
  return (
    <Box>
      <Container>
        <Loader src={require("../../assets/loader.gif")} alt="loader" />

        <LoaderText>{title}</LoaderText>
      </Container>
    </Box>
  );
};
